'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-textarea',
    cnTextarea = "".concat(CLASSNAME, "__textarea"),
    cnError = "".concat(CLASSNAME, "--error"),
    cnFocus = "".concat(CLASSNAME, "--focus"),
    cnTitle = "".concat(CLASSNAME, "__title");
/**
 * 
 */

function Textarea(_ref) {
  var _classNames;

  var className = _ref.className,
      name = _ref.name,
      onChange = _ref.onChange,
      optionalLabel = _ref.optionalLabel,
      placeholder = _ref.placeholder,
      requiredLabel = _ref.requiredLabel,
      required = _ref.required,
      title = _ref.title,
      validator = _ref.validator,
      value = _ref.value;

  var _useState = React.useState(false),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _rollupPluginBabelHelpers.slicedToArray(_useState3, 2),
      focus = _useState4[0],
      setFocus = _useState4[1];

  function onBlur(e) {
    if (error) {
      validate(e);
    }

    setFocus(false);
  }

  function onFocus() {
    setFocus(true);
  }

  function onInputChange(e) {
    var value = e.target.value;
    onChange(value);
  }

  function validate(e) {
    var value = e.target.value;

    if (required && !value) {
      setError(true);
      return;
    }

    if (validator && value) {
      setError(!value.match(validator));
      return;
    }

    setError(false);
  }

  return /*#__PURE__*/React__default.createElement("label", {
    className: classNames(CLASSNAME, className, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnError, error), _rollupPluginBabelHelpers.defineProperty(_classNames, cnFocus, focus), _classNames))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnTitle
  }, title, required ? requiredLabel : optionalLabel), /*#__PURE__*/React__default.createElement("textarea", {
    className: classNames(cnTextarea),
    placeholder: placeholder,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onInputChange,
    required: required,
    name: name,
    defaultValue: value,
    onInvalid: validate
  }));
}
Textarea.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** */
  name: PropTypes.string,

  /** */
  onChange: PropTypes.func,

  /** */
  optionalLabel: PropTypes.string,

  /** */
  placeholder: PropTypes.string,

  /** */
  requiredLabel: PropTypes.string,

  /** */
  required: PropTypes.bool,

  /** */
  title: PropTypes.string,

  /** */
  validator: PropTypes.instanceOf(RegExp),

  /** */
  value: PropTypes.string
};
Textarea.defaultProps = {
  iconId: 'info',
  onChange: function onChange() {
    return void 0;
  }
};

module.exports = Textarea;
